module.exports = __webpack_public_path__ + "img/collect-icon-music.06e31b8d.svg";